// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EItGF","colBig":"styles_colBig__2ekp_","colSmall":"styles_colSmall__1vngC","shopifyNameWrapper":"styles_shopifyNameWrapper__3Ky86"};